/** Travel up through the DOM hierarchy to find a parent element that matches the condition. */
const findParent =
  (condition: (el: HTMLElement) => boolean) => (el: HTMLElement) => {
    while (el) {
      if (el.nodeType === el.ELEMENT_NODE && condition(el)) {
        return el;
      } else {
        el = el.parentNode as HTMLElement;
      }
    }
    return null;
  };

export default findParent;
